import { translate } from '@sigma-frontend-libs/commons'
import globalMessages from '@sigma-frontend-libs/messages'

import localMessages from '@/messages'
import store from '@/store'

export const getTranslate = (path, options = {}) => {
  const sources = [ localMessages, globalMessages ]
  let locale = options.locale
  if (!locale) {
    locale = store.getters['locale/locale']
  }
  const translateOptions = {
    locale,
    replacements: options
  }

  return translate(path, sources, translateOptions)
}
